module.exports = __webpack_public_path__ + "static/media/background_peaks.5aa54d36.jpg";